import React from 'react';
import {Route, Routes} from 'react-router-dom';
import ToolVisitTracker from "./ToolVisitTracker";
import PageViewTracker from './PageViewTracker';
import { IMG_CLOUD_ROUTE_DEFINITIONS } from './definitions';

const AppRoutes: React.FC = () => {
  return (
    <>
      <ToolVisitTracker />
      <PageViewTracker />
      <Routes>
        {IMG_CLOUD_ROUTE_DEFINITIONS.map((definition) => (
          <Route
            key={definition.path}
            path={definition.path}
            element={definition.element}
          />
        ))}
      </Routes>
    </>
  );
};

export default AppRoutes;
